import { debounce } from "@itslearning/atlas/dom/Ratecontrol";

export default class UpdateHandler {
    constructor({ value, save, onError, onSuccess, active }) {
        this.internalValue = value;
        this.save = save;
        this.onError = onError;
        this.onSuccess = onSuccess;
        this.active = active;

        this.isSaving = false;
        this.isDirty = false;
        this.error = undefined;

        this.debounceSave = debounce(this.internalUpdate, 1000);
    }

    update(value, forceSave = false) {
        if (value !== this.internalValue) {
            this.internalValue = value;

            if (this.active) {
                this.isDirty = true;

                if (forceSave) {
                    this.internalUpdate();
                } else {
                    this.debounceSave();
                }
            }
        }
    }

    internalUpdate() {
        if (this.isSaving) {
            this.debounceSave();

            return;
        }

        this.isSaving = true;

        this.save(this.internalValue)
            .then(response => {
                this.isSaving = false;
                this.isDirty = false;
                this.error = undefined;

                if (this.onSuccess) {
                    this.onSuccess(response);
                }
            })
            .catch(error => {
                this.isSaving = false;
                this.isDirty = false;
                this.error = error;

                if (this.onError) {
                    this.onError(error);
                }
            });
    }
}
